import { render, staticRenderFns } from "./TabInfo.vue?vue&type=template&id=08cf5f19&scoped=true"
import script from "./TabInfo.vue?vue&type=script&lang=ts"
export * from "./TabInfo.vue?vue&type=script&lang=ts"
import style0 from "./TabInfo.vue?vue&type=style&index=0&id=08cf5f19&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08cf5f19",
  null
  
)

export default component.exports